import { render, staticRenderFns } from "./TranslatedTextRow.vue?vue&type=template&id=2bd2add3"
import script from "./TranslatedTextRow.vue?vue&type=script&lang=js"
export * from "./TranslatedTextRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports